// extracted by mini-css-extract-plugin
export var activeThumbnail = "ProductImages-module--activeThumbnail--a17b7";
export var customDots = "ProductImages-module--customDots--29a5e";
export var desktopImage = "ProductImages-module--desktopImage--b8bb8";
export var mobileImage = "ProductImages-module--mobileImage--e3a6b";
export var mobilePagination = "ProductImages-module--mobilePagination--5d5f7";
export var mobileSlider = "ProductImages-module--mobileSlider--8abe7";
export var productImageActive = "ProductImages-module--productImageActive--b88a1";
export var productImageThumb = "ProductImages-module--productImageThumb--fc9ab";